<template>
    <div>
        <SoilTexturesTable :results="results" />
    </div>
</template>
<script>
import SoilTexturesTable from '@/components/modus/result/views/detailed/tables/SoilTexturesTable.vue';
import ResultModel from "@/models/modus/ResultModel";

export default {
    name: "SoilTextureCharacteristics",
    components: { SoilTexturesTable },
    props: {
        results: {
            type: Object,
            default: () => new ResultModel
        }
    },
}
</script>